module.exports = __webpack_public_path__ + "img/crane-online.9c3438e9.png";